module.exports = __webpack_public_path__ + "img/multimedia_image.6d96b42b.jpg";